const formatPhone = (prefix?: string, val?: string, maxLen?: number) => {
  val = val ?? ''
  if (prefix && val.startsWith(prefix)) return val
  let s = `${prefix}${val}`
  const len = s.length
  if (maxLen && len > maxLen) {
    s = s.slice(0, maxLen)
  }
  return s
}

/**
 * 去掉电话号码前面的0
 * @param val
 * @returns
 */
const removePhoneZeroPrefix = (val: string) => {
  if (!val) return ''
  return val.replace(/^0+/, '')
}

/**
 * 使用正则表达式去除所有非数字字符
 * @param input
 * @returns
 */
const filterNonNumericCharacters = (input: string): string => {
  return input.replace(/\D/g, '')
}

const formatLink = (link: string) => {
  if (link.startsWith('http')) return link
  return `https://${link}`
}
export const useFormatUtil = () => ({
  formatPhone,
  removePhoneZeroPrefix,
  filterNonNumericCharacters,
  formatLink
})
